import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Seller } from '@app/feature/seller/seller';
import { map } from 'rxjs/operators';
import { DuplicatesCheckParams } from '@app/domain/model/duplicates-check-params';

@Injectable({
  providedIn: 'root'
})
export class DuplicatesCheckService {
  requestParams:HttpParams;

  constructor(private http: HttpClient) {
  }

  queryDuplicatesChecking(params: DuplicatesCheckParams, dealerId?: number): Observable<boolean> {

    this.requestParams = new HttpParams()
      .set('reportType', String(params.reportType))
      .set('reportDate', params.reportDate)
      .set('sellerId', String(params.sellerId));

    return this.http
      .get(`dealers/${dealerId ? dealerId : 'mine'}/reports/check-duplication/`, { headers: { 'Content-Type': 'application/json' }, params: this.requestParams })
      .pipe(
        map(response => {
          return response as boolean;
        })
      );
  }

}
